import Glide from "@glidejs/glide";
import "./styles.css";
import React, { useEffect } from "react";
import data from "./data";
import GlideSlide from "./GlideSlide";

const Slider = ({ onAdd }) => {
  const { products } = data;
  useEffect(() => {
    new Glide(".glide", {
      peek: 0,
      perView: 1,
      type: "carousel",
    }).mount();
  });
  return (
    <div className="glide">
      <div className="glide__arrows" data-glide-el="controls">
        <button
          onClick={(e) => e.preventDefault()}
          className="glide__arrow glide__arrow--left"
          data-glide-dir="<"
        >
          Prev
        </button>
      </div>
      <div className="glide__track" data-glide-el="track">
        <ul className="glide__slides">
          {products.map((product) => (
            <GlideSlide key={product.id} product={product} onAdd={onAdd} />
          ))}
        </ul>
      </div>
      <div className="glide__arrows" data-glide-el="controls">
        <button
          onClick={(e) => e.preventDefault()}
          className="glide__arrow glide__arrow--right"
          data-glide-dir=">"
        >
          Next
        </button>
      </div>
      {/* <!-- Thumbnails --> */}

      <div className="glide__bullets" data-glide-el="controls[nav]">
        <button className="glide__bullet" data-glide-dir="=0">
          <div className="thumbnail">
            <img src="./images/pic5.png" alt="" />
          </div>
        </button>

        <button className="glide__bullet" data-glide-dir="=1">
          <div className="thumbnail">
            <img src="./images/pic6.png" alt="" />
          </div>
        </button>

        <button className="glide__bullet" data-glide-dir="=2">
          <div className="thumbnail">
            <img src="./images/pic7.png" alt="" />
          </div>
        </button>

        <button className="glide__bullet" data-glide-dir="=3">
          <div className="thumbnail">
            <img src="./images/pic8.png" alt="" />
          </div>
        </button>
      </div>
    </div>
  );
};
export default Slider;
